import React from 'react';

function SearchList({data}) {

    function positionCheckForKr(positionTypeCode) {
        if(positionTypeCode*1 === 5201 || positionTypeCode*1 === 5211) return '투수';
        else return '타자';
    }   

    function handCheck(hand) {
        if(hand ==='R') return '우';
        else return '좌';
    }

    const playerProfileHandler = (event) => {
        let id = event.currentTarget.id;

        let idSplit = id.split('_');
        let positionTypeCode = idSplit[0];
        let playerId = idSplit[1];

        let playerType = (positionTypeCode*1 === 5201 || positionTypeCode*1 === 5211) ? 'pitcher' : 'batter';
        window.location.href = '/'+playerType+"/"+playerId;
    }

    return (
        <>
        {
        data.map((profile) => (
            <div className="search_player_item" id={profile['positionTypeCode']+"_"+profile['membersId']} key={profile['membersId']} onClick={playerProfileHandler}>
                <div className="title">{profile['membersName']} No.{profile['backnumber']}</div>
                <div className="content">
                    {profile['teamName']} {positionCheckForKr(profile['positionTypeCode'])} {handCheck(profile['pitchingHand'])}투{handCheck(profile['battingHand'])}타
                </div>
            </div>   
        ))
        }
        </>
    )
}

export default SearchList;